(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["chips-bar"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-country-flag]').forEach((el) => {
    const browserIso = (navigator.language.match(/-([A-Za-z]{2})$/) || [])[1];
    const iso = (browserIso || el.dataset.fallbackIso || '').toUpperCase();
    if (iso.length !== 2) return;
    el.textContent = String.fromCodePoint(
      ...[...iso].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65)
    );
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-countdown]').forEach((box) => {
    const minutes = parseInt(box.dataset.minutes, 10) || 3;
    const key = 'countdown-' + box.dataset.key + '-' + location.pathname;
    let start = parseInt(sessionStorage.getItem(key), 10);
    if (!start) {
      start = Date.now();
      sessionStorage.setItem(key, String(start));
    }

    const running = box.querySelector('.countdown-box__running');
    const expired = box.querySelector('.countdown-box__expired');
    const timeEl = box.querySelector('[data-countdown-time]');

    const tick = () => {
      const remaining = minutes * 60 - Math.floor((Date.now() - start) / 1000);
      if (remaining <= 0) {
        running.hidden = true;
        expired.hidden = false;
        clearInterval(interval);
        return;
      }
      const m = String(Math.floor(remaining / 60)).padStart(2, '0');
      const s = String(remaining % 60).padStart(2, '0');
      timeEl.textContent = m + ':' + s;
    };

    const interval = setInterval(tick, 1000);
    tick();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mini-review"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mini-review]').forEach((root) => {
    const items = root.querySelectorAll('.mini-review-item');
    if (items.length < 2) {
      root.querySelector('.mini-review__nav').hidden = true;
      return;
    }
    root.setAttribute('data-mini-review-ready', '');
    let index = 0;
    const show = () => {
      items.forEach((item, i) => {
        item.hidden = i !== index;
      });
    };
    root.querySelector('[data-mini-review-prev]').addEventListener('click', () => {
      index = (index - 1 + items.length) % items.length;
      show();
    });
    root.querySelector('[data-mini-review-next]').addEventListener('click', () => {
      index = (index + 1) % items.length;
      show();
    });
    show();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trusted-by-row"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-trusted-loop]').forEach((scroller) => {
    const items = [...scroller.children];
    if (items.length < 2) return;

    // Fotoset verdubbelen zodat er na de laatste altijd weer een eerste komt
    items.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      scroller.appendChild(clone);
    });

    // Zodra de scroll voorbij de originele set is, ongemerkt terugspringen —
    // de gekloonde set staat er identiek, dus de sprong is onzichtbaar.
    let wrapping = false;
    scroller.addEventListener('scroll', () => {
      if (wrapping) return;
      const setWidth = scroller.scrollWidth / 2;
      if (scroller.scrollLeft >= setWidth) {
        wrapping = true;
        scroller.scrollLeft -= setWidth;
        requestAnimationFrame(() => { wrapping = false; });
      }
    }, { passive: true });
  });
  } catch(e) { console.error(e); }
})();

})();
